import type { ContextRating, IThreadAIContextFeedback } from "@interfaces/thread.interface";
import { useFeedbackOptions } from "./useFeedbackOptions";
import { useCreateFeedback } from "./useCreateFeedback";
import { useUpdateFeedback } from "./useUpdateFeedback";

export function useContextFeedback(threadId: string, feedback?: IThreadAIContextFeedback | null) {
  const { feedbackOptions, isLoadingOptions } = useFeedbackOptions();
  const createMutation = useCreateFeedback(threadId);
  const updateMutation = useUpdateFeedback(threadId);

  // PATCH once a rating exists: re-POSTing the same generation is a 409.
  const submitRating = (rating: ContextRating) => {
    if (feedback) {
      updateMutation.mutate({ rating });
      return;
    }

    createMutation.mutate({ thread_id: threadId, rating });
  };

  const submitThumbsUp = () => submitRating("thumbs_up");

  const submitThumbsDown = () => submitRating("thumbs_down");

  // Returns the promise so callers only confirm success once the server accepts it.
  const submitReasons = (reasons: string[], comment: string) =>
    updateMutation.mutateAsync({
      reasons,
      ...(comment ? { comment } : {}),
    });

  return {
    feedbackOptions,
    isLoadingOptions,
    submitThumbsUp,
    submitThumbsDown,
    submitReasons,
    isSubmitting: createMutation.isPending || updateMutation.isPending,
  };
}
